/* eslint semi: 1 */
import { defineStore } from 'pinia';
import type { components } from '@base-shared/types/media.openapi';

type MediaItem = components['schemas']['MediaItem'];

interface MediaSelectionState {
  selection: MediaItem[];
  isFetchingDetails: boolean;
  anchorItem: MediaItem | null;
};

export const useMediaSelectionStore = defineStore('media-selection-store', {
  state: (): MediaSelectionState => ({
    selection: [], // Array<{ resourceId: string, [key: string]: any }>
    isFetchingDetails: false,
    anchorItem: null, // Tracks the anchor item for shift-range selection.
  }),
  getters: {
    /** True when at least one item is selected. */
    hasSelection: (state) => state.selection.length > 0,
  },
  actions: {
    setSelection (items: MediaItem[]) {
      this.selection = items;
    },
    setAnchorItem (item: MediaItem | null) {
      this.anchorItem = item;
    },
    setIsFetchingDetails (isFetching: boolean) {
      this.isFetchingDetails = isFetching;
    },
    populateSelectedItemsDetails (detailedItems: MediaItem[]) {
      this.selection = this.selection.map(item => {
        const detailedItem = detailedItems.find(d => d.resourceId === item.resourceId);
        return detailedItem ? { ...item, ...detailedItem } : item;
      });
    },

    addItem (item: MediaItem) {
      if (!item?.resourceId) return;
      if (this.selection.some(s => s.resourceId === item.resourceId)) return; // Avoid duplicates
      this.selection.push(item);
    },
    removeItem (item: MediaItem) {
      if (!item?.resourceId) return;
      this.selection = this.selection.filter(s => s.resourceId !== item.resourceId);
    },
    clearSelection () {
      this.selection = [];
      this.anchorItem = null;
    },

    reset () {
      this.$patch({
        selection: [],
        isFetchingDetails: false,
        anchorItem: null
      });
    }
  }
});
